// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-cms-editor',
    // #endregion
    data: () => ({
        body: true,
        edit: false,
        disabled: false,
        edit2: false
    }),
    methods: {
        onClick() {
            if (!this.edit) {
                host.notification.showModal2(host.components.getComponent('g-document-dialog'), { documentType: 'cart', documentID: '010fca47-700a-49f0-8e9d-f62fd529eb5d' }, { variant: "popup", position: "bottom", size: "large" });
            }
        },
        disableSort() {
        },
        addNewBlock(e) {
            host.notification.showModal2(host.components.getComponent('g-document-dialog'), { documentType: 'cart', documentID: '010fca47-700a-49f0-8e9d-f62fd529eb5d' }, { variant: "popup", position: "bottom", size: "large" });
        },
        deleteBlock(e) {
        },
        saveBlock() {
        },
        cancel() {
            this.edit = false;
        },
        submitBlock() {
        },
        getData() {
            host.notification.showModal2(host.components.getComponent('g-document-dialog'), { documentType: 'cart', documentID: '010fca47-700a-49f0-8e9d-f62fd529eb5d' }, { variant: "slide", position: "end", size: "default" });
        }
    },
});
// #endregion
